import styled from 'styled-components';
import { BackgroundColor, Spacer } from '@lux/tokens';
import { Title } from '@lux/title';
import { ChevronLeftXS } from '@lux/zds-icons';
import { screenSmallerThan, Screen } from '@client/styles/styled-components/breakpoints';

export const MainWrapper = styled.main`
    position: relative;
    background-color: ${BackgroundColor.mylounge};
    .lux-grid-page-layout {
        ${screenSmallerThan(Screen.smallTablet)} {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;

export const TitleWrapper = styled(Title)`
    margin: 0;
    text-transform: initial;
    ${screenSmallerThan(Screen.smallTablet)} {
        padding-left: ${Spacer.S};
    }
`;

export const CampaignsWrapper = styled.div`
    padding: ${Spacer.XL} 0 ${Spacer.M} 0;
    ${screenSmallerThan(Screen.smallTablet)} {
        padding: ${Spacer.M} 0 ${Spacer.SM} 0;
    }
`;

export const BreadcrumbWrapper = styled.div`
    padding: ${Spacer.M} 0 ${Spacer.M} 0;
    ${screenSmallerThan(Screen.smallTablet)} {
        padding-left: ${Spacer.S};
    }
`;

export const StyledChevronLeft = styled(ChevronLeftXS)`
    margin-right: ${Spacer.S};
`;
